import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverHelpComponent } from './popover-help.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
    declarations: [PopoverHelpComponent],
    imports: [
        CommonModule,
        IonicModule
    ],
    exports: [PopoverHelpComponent]
})
export class PopoverHelpModule { }

